import React, { useEffect, useState } from 'react'

import useFirebase from 'hooks/firebase'

import { Link as RouterLink } from 'react-router-dom'

import {
  Card,
  CardContent,
  Grid, 
  IconButton,
  Typography,
  useMediaQuery
} from '@mui/material'

import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import { DataGrid, esES } from '@mui/x-data-grid'
import CreateStudent from 'widgets/students/create'
import BulkStudents from 'widgets/students/bulk'

const Students = (props) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('xs'))

  const { auth, firestore } = useFirebase()
  const { credentials } = auth
  const { director, getDirector, getStudentsBySchoolId, students } = firestore

  const [rows, setRows] = useState([])

  const columns = [
    // { field: 'id', headerName: 'ID', width: 70 },
    { 
      field: 'name', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Nombre'}</b>
      ),
      renderCell: (params) => (
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <b>{params.value}</b>
        </span>
      ),
      minWidth: 200,
      flex: 2,
      hideable: false,
    },
    { 
      field: 'email', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Email'}</b>
      ), 
      minWidth: 240,
      flex: 2,
    },
    { 
      field: 'preceptor', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Preceptor'}</b>
      ), 
      minWidth: 200,
      flex: 1,
      hide: isMobile
    },
    { 
      field: 'stage', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Nivel'}</b>
      ), 
      minWidth: 140,
      flex: 0,
    },
    { 
      field: 'id',
      headerName: '',
      flex: 0,
      renderCell: (params) => (
        <IconButton component={RouterLink} to={`${params.value}`}>
          <ChevronRightIcon />
        </IconButton>
      ),
      type: 'singleSelect',
      align: 'right',
      sortable: false,
      filterable: false,
      hideable: false,
    },
  ]

  useEffect(() => {
    if (credentials === undefined) return
    getDirector(credentials.uid)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [credentials])
  
  useEffect(() => {
    if (director === undefined) return
    getStudentsBySchoolId(director.schoolId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [director])

  useEffect(() => {
    if (students === undefined) return

    var data = []
    students.forEach((student) => {
      data.push({
        'id': student['id'],
        'name': student['name'],
        'email': student['email'],
        'stage': student['level'],
        'preceptor':  student['preceptor'] !== undefined ? student['preceptor']['name'] : 'Sin asignar',
      })
    })
    setRows(data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [students])

  return (
    <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Typography color='primary' variant='h4'>
          <b style={{ fontWeight: 900 }}>Alumnos</b>
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <BulkStudents director={director} />
          </Grid>
          <Grid item xs={12}>
            <CreateStudent director={director} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={9}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1'>
                  <b style={{ fontWeight: 900 }}>LISTA DE ALUMNOS</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  autoHeight
                  disableSelectionOnClick
                  // disableColumnMenu
                  columns={columns}
                  localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                  pageSize={10}
                  rows={rows}
                  rowsPerPageOptions={[10]}
                  sx={{ borderWidth: 0 }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default Students